import React from 'react';

import NotFound from '@components/NotFound';

import OrgSettingLayout from '@views/Organization/OrgSettingManagementLayout';

export default function ManageDataRetentionPage(
  props: PagePropsWithBreadcrumbs
) {
  return (
    <OrgSettingLayout pageProps={props}>{() => <NotFound />}</OrgSettingLayout>
  );
}
